import { render, staticRenderFns } from "./fccTratamentoCandidatos.vue?vue&type=template&id=062e6542"
import script from "./fccTratamentoCandidatos.vue?vue&type=script&lang=js"
export * from "./fccTratamentoCandidatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports